import {IMuiSelectOption} from "../config/mui";
import {IPaymentMethod} from "../config/payment_method";

export const transformToMuiSelectFormat = (data: IPaymentMethod[]): IMuiSelectOption[] => {
    return data.map(({id, name}) => {
        return {value: id, label: name};
    });
};
